/* eslint-disable no-local-storage/no-local-storage */
/* eslint-disable no-use-effect/no-use-effect */
import { Flex } from '@mantine/core';
import { UserRole } from '@repo/common/enums/UserRole';
import { lowerCase, map } from 'lodash-es';
import { useEffect } from 'react';
import { useNavigate } from 'react-router';
import { useAuthUser } from '../../api';
import { useOnboarding } from '../../hooks/useOnboarding/index.ts';
import { useUserOnboarding } from '../../hooks/useUserOnboarding';
import { REDIRECT_FROM_AUTH_PATH_KEY } from '../../pages/RootPage/constants';
import { useFeatureFlags } from '../../utils/featureFlags/useFeatureFlags.ts';
import { LoadingSpinner } from '../LoadingSpinner';

const VIEWER_ROLES = map([UserRole.VIEWER, UserRole.GUEST], lowerCase);

// This component's role is to redirect to either the home screen or the
// onboarding screen after a user finished either logging in, creating a
// profile, or creating a workspace.
export function AuthStepConfirm() {
	const navigate = useNavigate();
	const { secodaLiteOnboarding } = useFeatureFlags();
	const { user, isLoading } = useAuthUser();
	const { viewerOnboardingStepCompletion } = useUserOnboarding();
	const { isConnectIntegrationComplete, isLoading: isOnboardingLoading } =
		useOnboarding();

	useEffect(() => {
		function redirectFromAuthPath() {
			const to = localStorage.getItem(REDIRECT_FROM_AUTH_PATH_KEY);
			localStorage.removeItem(REDIRECT_FROM_AUTH_PATH_KEY);
			navigate(to ?? '/');
		}

		if (!isLoading && !isOnboardingLoading) {
			const role: string | undefined = user?.role?.toLowerCase();
			const isViewerUser: boolean = !!(role && VIEWER_ROLES.includes(role));
			if (isViewerUser) {
				// viewer/guest onboarding
				if (!viewerOnboardingStepCompletion.welcomePageSeen) {
					navigate('/onboarding/welcome');
				} else {
					redirectFromAuthPath();
				}
			} else {
				// admin/editor onboarding
				if (isConnectIntegrationComplete || !secodaLiteOnboarding) {
					redirectFromAuthPath();
				} else {
					navigate('/onboarding/welcome_lite');
				}
			}
		}
	});

	return (
		<Flex h="100vh">
			<LoadingSpinner />
		</Flex>
	);
}
